module.exports = __webpack_public_path__ + "static/Resin bonded brigde smile_after-bf4da66adad5e90f9b4e1682c4bc5e13.jpg";